import React from "react";
import { requireAuth } from "../util/auth.js";
// import RatingsSection from "./../components/RatingsSection";
import AlgoliaSearch from "./../components/AlgoliaSearch";


function Search(props) {
    return (
      <AlgoliaSearch
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Add Coffee"
      subtitle=""
      buttonText="Add"
      buttonColor="primary"
      showNameField={true}
      inputSize="md"
    />
  );
}

export default requireAuth(Search);